import ErrorBoundary from '@/components/ErrorBoundary';
import { ContentProps } from 'types/content';
import { StandaloneVideoArticle, StandaloneVideoArticleProps } from '../JwVideo/Article';
import { getB2BVideoInfo, getVideoOptions } from '../JwVideo/Article/utils/dataParser';
import { Youplay } from './Youplay';
import { YouplayNotFoundProps } from './Youplay.NotFound';
import { YouplayNotFoundTextProps } from './Youplay.NotFound.Text';

export interface StandaloneYouplayProps extends StandaloneVideoArticleProps {
  options?: StandaloneVideoArticleProps['options'] & {
    $notFound?: YouplayNotFoundProps;
    $text?: YouplayNotFoundTextProps;
  };
}

export function StandaloneYouplayVideo(props: StandaloneYouplayProps) {
  const {
    playerId,
    showDescription,
    videoPageLink,
    durationMinutes,
    titleTextSize,
    metadata,
    videoData,
    b2bVideo,
    options,
    ...baseProps
  } = props;
  const { $notFound: notFoundProps, $text: textProps, ...videoArticleProps } = options || {};

  return (
    <ErrorBoundary>
      <Youplay {...baseProps}>
        {videoData?.videoId ? (
          <StandaloneVideoArticle
            playerId={playerId}
            videoData={videoData}
            b2bVideo={b2bVideo}
            showDescription={showDescription}
            durationMinutes={durationMinutes}
            videoPageLink={videoPageLink}
            titleTextSize={titleTextSize}
            metadata={metadata}
            {...videoArticleProps}
          />
        ) : (
          <Youplay.NotFound {...notFoundProps}>
            <Youplay.NotFound.Text {...textProps}>Videon kunde inte hittas</Youplay.NotFound.Text>{' '}
          </Youplay.NotFound>
        )}
      </Youplay>
    </ErrorBoundary>
  );
}

function ContentYouplay({ type, data, meta, descendants }: ContentProps) {
  const videoOptions = getVideoOptions(data);
  const b2bVideoInfo = getB2BVideoInfo(data);

  const { enableDesc, fieldSettings, durationMinutes, playerID, teaserLink, videoMetaData } = data;

  const titleTextSize = fieldSettings?.title?.textSize;

  return (
    <StandaloneYouplayVideo
      playerId={playerID}
      videoData={videoOptions}
      b2bVideo={b2bVideoInfo}
      showDescription={enableDesc}
      durationMinutes={durationMinutes}
      videoPageLink={teaserLink}
      titleTextSize={titleTextSize}
      metadata={videoMetaData}
      data-content-index={meta.contentIndex}
    ></StandaloneYouplayVideo>
  );
}

export const standalone = StandaloneYouplayVideo;

export default ContentYouplay;
